/**
 * Makes menu sticky.
 */

import stickybits from 'stickybits';

jQuery( $ => { // eslint-disable-line no-unused-vars
	const disableStickyMenu = wp.hooks.applyFilters( 'qala_theme.filter.pre_disable_sticky_menu', false );

	const setHeaderHeight = () => {
		const header = document.querySelector( '.site-header' );
		if ( header ) {
			const headerHeight = header.offsetHeight;
			// Set on both :root and body to ensure it's available everywhere
			document.documentElement.style.setProperty( '--qala-header-height', `${ headerHeight }px` );
			document.body.style.setProperty( '--qala-header-height', `${ headerHeight }px` );
		}
	};

	setHeaderHeight();

	// Update on window resize (debounced)
	let resizeTimer;
	window.addEventListener( 'resize', () => {
		clearTimeout( resizeTimer );
		resizeTimer = setTimeout( () => {
			setHeaderHeight();
		}, 250 );
	} );

	// Update after sticky menu initializes (in case height changes)
	if ( ! disableStickyMenu ) {
		const stickyArgs = {
			useStickyClasses: true,
		};

		stickybits( '.site-header', stickyArgs );

		// Recalculate after stickybits applies its classes
		setTimeout( setHeaderHeight, 100 );
	}
} );
